import KItem from 'app/components/Modules/General/KItem'
import { RecordType } from 'app/constants/GlobalTypes'
import { ToolBox } from 'app/lib/hooks/toolBox'
import React, { ComponentProps, useMemo } from 'react'

import { MemberProps } from '../convention'

type Props = Partial<ComponentProps<typeof KItem>>

const SubItemDetail: React.FC<MemberProps<Partial<ISubItem>, Props>> = ({ member, props = {} }) => {
  const { tRecordType } = ToolBox.useString()

  const getTitle = useMemo(() => {
    if (member.freeAttachment) {
      return `${member.name} (${tRecordType(RecordType.subItem, 'inclusive')})`
    } else {
      return member.name
    }
  }, [member])

  return (
    <KItem
      title={getTitle}
      avatar={<img src={member.image_url} alt={member.name} height={45} width={45} />}
      {...props}
    />
  )
}

export default SubItemDetail
